export var MuiTextFieldTheme = {
    defaultProps: {
        size: 'small'
    },
    variants: [{
            props: {
                size: "small"
            },
            style: {
                fontSize: "14px",
                lineHeight: "20px"
            }
        }, {
            props: {
                size: "medium"
            },
            style: {
                fontSize: "16px",
                lineHeight: "24px"
            }
        }]
};
